export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    // infoWrap
    initial: width => ({
        x: width > 500 ? '0' : 'calc(100% - 2rem)',
        transition: {
            ...transition,
            x: { ...transition, delay: .1 }
        },
        backgroundColor: 'rgba(255,255,255,0)',
    }),
    animate: {
        x: '0',
        backgroundColor: 'rgba(255,255,255,1)',
    },
    // infoWrapInner
    initial2: {
        opacity: 0,
    },
    animate2: {
        opacity: 1,
        transition: {
            ...transition,
            delay: .1
        }
    }
}